/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.to-string.js";
import request from '@/api/request'; // 获取首页列表

export function getHomeFunctionList(data) {
  return request.get('/v2/menu/mobile/getList', {
    params: data
  });
} // 获取所有功能导航及待办事项列表

export function getAllFunctionList(data) {
  return request.get('/v2/menu/mobile/getWaitList', {
    params: data
  });
} // 获取代办事项数量

export function getToDoCount(data) {
  return request.get('/v2/menu/mobile/getCount', {
    params: data
  });
} // 获取通知列表

export function getHomeNoticeList(data) {
  return request.get('/v2/menu/mobile/noticeList', {
    params: data
  });
} // 获取待办事项列表

export function getHomeWaitToDoList(data) {
  return request.get('/v2/menu/mobile/waitToDoList', {
    params: data
  });
} // 获取功能导航列表

export function getHomeProcessList(data) {
  return request.get('/v2/menu/mobile/processList', {
    params: data
  });
} // 修改角色

export function changeRole(data) {
  return request.post('/user/changeRole', data);
} // 获取功能导航列表徽标数量

export function getHomeProcessCount(data) {
  return request.get('/v2/menu/mobile/processCount', {
    params: data
  });
}
export function systemgetServiceAddress(data) {
  return request.get('/v2/system/getServiceAddress', {
    params: data
  });
}
export function geproductQRfiledDetail() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request.get('/productQR/filedDetail', {
    params: data
  });
}
/**
 * api@v2.8
 */

export function getHomeNav() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Promise.resolve({
    success: true,
    message: '',
    data: [{
      id: -1,
      nid: 1,
      name: '功能区',
      type: 1,
      order_num: 1,
      show_state: 1,
      cardMenuList: [{
        id: -1,
        nid: 1,
        name: '项目管理',
        code: 10001,
        img_url: null,
        cardId: 1,
        order_num: 1,
        show_state: 1
      }, {
        id: -1,
        nid: 2,
        name: '工单管理',
        code: 10002,
        img_url: null,
        cardId: 1,
        order_num: 2,
        show_state: 1
      }, {
        id: -1,
        nid: 3,
        name: '现场管理',
        code: 10003,
        img_url: null,
        cardId: 1,
        order_num: 3,
        show_state: 1
      }, {
        id: -1,
        nid: 4,
        name: '服务绩效',
        code: 10004,
        img_url: null,
        cardId: 1,
        order_num: 4,
        show_state: 1
      }, {
        id: -1,
        nid: 5,
        name: '费用报销',
        code: 10005,
        img_url: null,
        cardId: 1,
        order_num: 5,
        show_state: 1
      }, {
        id: -1,
        nid: 6,
        name: '服务商结算',
        code: 10006,
        img_url: null,
        cardId: 1,
        order_num: 6,
        show_state: 1
      }, {
        id: -1,
        nid: 7,
        name: '知识库',
        code: 10007,
        img_url: null,
        cardId: 1,
        order_num: 7,
        show_state: 1
      }, {
        id: -1,
        nid: 8,
        name: '仓库管理',
        code: 10008,
        img_url: null,
        cardId: 1,
        order_num: 8,
        show_state: 1
      }]
    }]
  }); // return request.get('/role/navigation/getShowState', { params: data })
}
export function postHomeNav(data) {
  return request.post('/role/navigation/saveCardShowState', data);
}
export function postHomeChildNav(data) {
  return request.post('/role/navigation/saveMenuShowState', data);
}
/**
 * api@2.9
 */

export function getProductType(data) {
  return request.get('/v2/product/typeList', {
    params: data
  });
}
export function getProductModel(data) {
  return request.get('/product/productFiled', {
    params: data
  });
}
export function postProductSave(data) {
  return request.post('/product/saveProduct', JSON.stringify(data), {
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    }
  });
}
export function getProductCustomerList(data) {
  return request.get('/v2/product/productCustomeList', {
    params: data
  });
}
export function getProductCustomerCount(data) {
  return request.get('/v2/product/productCustomeCount', {
    params: data
  });
}
export function postHdHdprojectproductUpdateScrapDestination(data) {
  return request.post('/hd/hdprojectproduct/updateScrapDestination', data);
}
export function getHdProjectproductGetScrapFile(data) {
  return request.get('/hd/hdprojectproduct/getScrapFile', {
    params: data
  });
}
export function getHdProjectproductGetOperateVideo(data) {
  return request.get('/hd/hdprojectproduct/getOperateVideo', {
    params: data
  });
}
export function getHdProjectproductGetCabinetNo(data) {
  return request.get('hd/hdprojectproduct/getCabinetNo', {
    params: data
  });
}
export * from './faq';
export * from './doc';
export * from './sparepartstock';
export * from './mysparepart';
export * from './sparepartexamine';
export * from './sparepartlog';
export * from './stocklog';
export * from './notice';
export * from './orderSea';